import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "calendar-wrapper" }
const _hoisted_2 = { class: "calendar-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "mc-monthCell"
}
const _hoisted_6 = { style: {"font-size":"10px","color":"red"} }
const _hoisted_7 = { class: "mc-events-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "mc-indicator" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "modal-content1" }
const _hoisted_13 = { class: "modal-content1" }
const _hoisted_14 = { class: "event-list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "event-info" }
const _hoisted_17 = { class: "event-title" }
const _hoisted_18 = {
  key: 0,
  class: "no-event"
}
const _hoisted_19 = { class: "modal-content1" }
const _hoisted_20 = { style: {"color":"black"} }

import { ref, onMounted, reactive, computed, onUnmounted } from 'vue';

// FullCalendar 관련 import
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import koLocaleFullCalendar from '@fullcalendar/core/locales/ko';
import listPlugin from '@fullcalendar/list';
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import axios from '@/api/plan'; // axios import 경로 확인
import CalendarLegend from '@/components/sub/CalendarLegend.vue'; // CalendarLegend import 경로 확인



export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarView',
  props: {
    isDark: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const dayEvents = ref<any[]>([]);
const selectedDate = ref<Date | null>(null);
const selectedEvent = ref({
  title: '',
  start: null as Date | null,
  end: null as Date | null,
  description: ''
});



const isModalOpen = ref(false);
const isModalVueOpen = ref(false);
const isDetailOpen = ref(false);
const backgroundImage = ref('');

const isMobile = ref(window.innerWidth < 920); // PC와 모바일 전환 기준 픽셀 (조절 가능)

function updateIsMobile() {
  isMobile.value = window.innerWidth < 920;
}


// 캘린더 이벤트 데이터 (ref로 관리)
const fullCalendarEvents = ref<any[]>([]); // FullCalendar용 이벤트 데이터
const vueCalEvents = ref<any[]>([]);       // VueCal용 이벤트 데이터

// FullCalendar 컴포넌트 인스턴스 참조 (타입 명시하여 'never' 에러 방지)
const fullCalendarRef = ref<InstanceType<typeof FullCalendar> | null>(null);
// VueCal 컴포넌트 인스턴스 참조 (VueCal 타입이 필요하다면 정의하거나 any 사용)

// FullCalendar 옵션 설정 (reactive 객체로 선언)
const fullCalendarOptions = reactive({
  plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin], // 사용하는 모든 플러그인 명시
  locale: koLocaleFullCalendar, // 한국어 로케일
  dayMaxEventRows: true, // 하루에 표시할 이벤트 최대 줄 수
  eventDisplay: 'block', // 이벤트 표시 방식 (블록)
  initialView: 'dayGridMonth', // 초기 뷰 (onMounted에서 isMobile에 따라 변경 예정)
  headerToolbar: { // 캘린더 헤더 툴바 설정
    left: 'prev,next today',
    center: 'title',
    right: '', // onMounted에서 isMobile에 따라 변경 예정
  },
  datesSet: (info: any) => { // 캘린더 날짜 범위 변경 시 호출
    const currentStartDate = new Date(info.view.currentStart);
    const month = currentStartDate.getMonth() + 1;
    fetchBackground(month); // 배경 이미지 업데이트
  },
  buttonText: { // 버튼 텍스트 한글화
    today: '오늘',
  },
  events: (fetchInfo: any, successCallback: any, failureCallback: any) => {
    successCallback(fullCalendarEvents.value);
  },
  eventDidMount(info: any) { // 이벤트 요소가 DOM에 마운트된 후
    info.el.style.position = 'relative';
    info.el.style.zIndex = '10';
    info.el.style.transition = 'transform 0.2s ease';
    info.el.addEventListener('mouseenter', () => {
      info.el.style.transform = 'scale(1.05)';
      info.el.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.2)';
      info.el.style.zIndex = '10';
      info.el.style.cursor = 'pointer';
    });
    info.el.addEventListener('mouseleave', () => {
      info.el.style.transform = 'scale(1)';
      info.el.style.boxShadow = '';
      info.el.style.zIndex = '';
    });
  },
  contentHeight: 'auto',
  aspectRatio: 1.35,
  dayCellDidMount(info: any) { // 날짜 셀이 DOM에 마운트된 후
    const dateStr = info.date.toISOString().slice(0, 10);
    const eventsForThisDay = fullCalendarEvents.value.filter(event =>
      event.start.startsWith(dateStr)
    );
    if (eventsForThisDay.length > 0) {
      const tooltipContent = eventsForThisDay
        .map(ev => `• ${ev.title}`)
        .join('\n');
      info.el.setAttribute('title', tooltipContent);
    }
  },
  eventClick: handleFullCalendarEventClick, // 이벤트 클릭 핸들러
});



// 배경 이미지 불러오기
async function fetchBackground(month: number) {
  try {
    const response = await axios.backgroundList(month);
    backgroundImage.value = response.data.path;
  } catch (error) {
    console.error("배경 이미지를 불러오는 데 실패했습니다:", error);
    backgroundImage.value = '';
  }
}

function onCellClick(date: Date | null) {
  if (!date) return;
  const eventsOfDay = vueCalEvents.value.filter(e => new Date(e.start).toDateString() === date.toDateString());
  if (!eventsOfDay.length) return;
  selectedDate.value = date;
  dayEvents.value = eventsOfDay;
  isModalVueOpen.value = true;
}

function showDetail(ev: any) {
  selectedEvent.value = ev;
  isDetailOpen.value = true;
  isModalVueOpen.value = false;
}


// ⭐ 일정 데이터 불러오기 (fetchPlan 함수)
async function fetchPlan() {
  try {
    const response = await axios.ListPlan(); // API 호출
    const rawEvents = response.data || []; // 데이터 안전하게 가져오기

    // FullCalendar용 데이터 형식 변환 및 할당
    fullCalendarEvents.value = rawEvents.map((event: any) => ({
      id: event.id,
      title: event.title,
      start: event.start, // 서버에서 받은 ISO 8601 문자열 또는 Date 객체 그대로 사용
      end: event.end,
      description: event.description || '',
      backgroundColor: event.backgroundColor || '',
      borderColor: event.backgroundColor || '',
      extendedProps: {
        description: event.description || ''
      },
      classNames: event.backgroundColor ? [`event-color-${event.backgroundColor.replace('#', '')}`] : []
    }));

    // VueCal용 데이터 형식 변환 및 할당 (Date 객체로 변환)
    vueCalEvents.value = rawEvents.map(e => ({
      id: e.id,
      start: new Date(e.start),
      end: new Date(e.end),
      title: e.title,
      backgroundColor: e.backgroundColor,
      allDay: true
    }));

    console.log('fetchPlan: 데이터 로드 완료. FullCalendar 이벤트 수:', fullCalendarEvents.value.length);

  } catch (error) {
    console.error('fetchPlan: 일정 목록을 불러오는 데 실패했습니다:', error);
  }
}

function handleVueCalViewChange(payload: { startDate: Date, endDate: Date, view: string }) {
  if (payload.view === 'month') {
    const month = payload.startDate.getMonth() + 1;
    fetchBackground(month);
  }
}

function handleFullCalendarEventClick(info: any) {
  const event = info.event;
  selectedEvent.value = {
    title: event.title,
    start: event.start,
    end: event.end,
    description: event.extendedProps.description || ''
  };
  isModalOpen.value = true;
}

function formatDateDay(date: Date | null) {
  if (!date) return '';
  const d = new Date(date);
  const year = d.getFullYear();
  const month = d.getMonth() + 1; // 0-based
  const day = d.getDate();
  return `${year}년 ${month}월 ${day}일`;
}

function formatTime(date: Date | string | null) {
  if (!date) return '';
  const d = new Date(date);
  return new Intl.DateTimeFormat('ko-KR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(d);
}


// --- 컴포넌트 마운트 시 실행되는 로직 (핵심) ---
onMounted(async () => {
  // 1. **가장 먼저 데이터 로드:** `fetchPlan`이 완료될 때까지 기다립니다. (⭐ await 추가)
  await fetchPlan();


  const initialMonth = new Date().getMonth() + 1;
  fetchBackground(initialMonth);

  if (!isMobile.value && fullCalendarRef.value) {
    const api = fullCalendarRef.value.getApi();
    api.refetchEvents();
  }

});

onMounted(() => {
  window.addEventListener('resize', updateIsMobile);
});
onUnmounted(() => {
  window.removeEventListener('resize', updateIsMobile);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[6] || (_cache[6] = _createElementVNode("h1", null, "일정표", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "calendar-background",
          style: _normalizeStyle({ backgroundImage: `url('${backgroundImage.value}')` })
        }, null, 4),
        _createElementVNode("div", {
          class: _normalizeClass([{ 'dark-calendar': _ctx.isDark }, "calendar-main-area"])
        }, [
          _createVNode(CalendarLegend),
          (!isMobile.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(FullCalendar), {
                  options: fullCalendarOptions,
                  ref_key: "fullCalendarRef",
                  ref: fullCalendarRef
                }, null, 8, ["options"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_unref(VueCal), {
                  class: "vuecal-custom-theme",
                  events: vueCalEvents.value,
                  locale: "ko",
                  "active-view": "month",
                  "disable-views": ['years', 'year', 'week', 'day'],
                  "hide-view-selector": "",
                  "week-start": "0",
                  onCellClick: onCellClick,
                  onViewChange: handleVueCalViewChange
                }, {
                  cell: _withCtx(({ day, events = [], view, outside }) => [
                    (view === 'month')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, " 🔥 이벤트 개수: " + _toDisplayString(events.length), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["mc-date-small", { 'mc-outside': outside }])
                          }, _toDisplayString(day.getDate()), 3),
                          _createElementVNode("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events, (ev) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: ev.id,
                                class: "mc-event-item",
                                onClick: _withModifiers(($event: any) => (onCellClick(day)), ["stop"])
                              }, _toDisplayString(ev.title), 9, _hoisted_8))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.slice(0, 3), (ev) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: ev.id,
                                class: "mc-dot",
                                style: _normalizeStyle({ backgroundColor: ev.backgroundColor }),
                                onClick: _withModifiers(($event: any) => (onCellClick(day)), ["stop"])
                              }, null, 12, _hoisted_10))
                            }), 128)),
                            (events.length > 3)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "mc-more-count",
                                  onClick: _withModifiers(($event: any) => (onCellClick(day)), ["stop"])
                                }, "+" + _toDisplayString(events.length
                    - 3), 9, _hoisted_11))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["events"])
              ]))
        ], 2),
        (isModalOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-overlay",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isModalOpen.value = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h1", null, _toDisplayString(selectedEvent.value.title), 1),
                _createElementVNode("h2", null, _toDisplayString(formatDateDay(selectedEvent.value.start)), 1),
                _createElementVNode("p", null, _toDisplayString(formatTime(selectedEvent.value.start)) + " ~ " + _toDisplayString(formatTime(selectedEvent.value.end)), 1),
                _createElementVNode("p", null, _toDisplayString(selectedEvent.value.description), 1),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isModalOpen.value = false)),
                  class: "close-btn"
                }, "닫기")
              ])
            ]))
          : _createCommentVNode("", true),
        (isModalVueOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "modal-overlay",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (isModalVueOpen.value = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h2", null, _toDisplayString(formatDateDay(selectedDate.value)), 1),
                _createElementVNode("ul", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dayEvents.value, (ev) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: ev.id,
                      class: "event-item",
                      onClick: ($event: any) => (showDetail(ev)),
                      style: {"list-style-type":"none","color":"black"}
                    }, [
                      _createElementVNode("span", {
                        class: "event-color-dot",
                        style: _normalizeStyle({ backgroundColor: ev.backgroundColor })
                      }, null, 4),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(ev.title), 1)
                      ])
                    ], 8, _hoisted_15))
                  }), 128)),
                  (!dayEvents.value.length)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_18, "일정이 없습니다."))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isModalVueOpen.value = false)),
                  class: "close-btn"
                }, "닫기")
              ])
            ]))
          : _createCommentVNode("", true),
        (isDetailOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "modal-overlay",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (isDetailOpen.value = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h3", _hoisted_20, _toDisplayString(selectedEvent.value.title), 1),
                _createElementVNode("p", null, _toDisplayString(formatDateDay(selectedEvent.value.start)), 1),
                _createElementVNode("p", null, _toDisplayString(formatTime(selectedEvent.value.start)) + " ~ " + _toDisplayString(formatTime(selectedEvent.value.end)), 1),
                _createElementVNode("p", null, _toDisplayString(selectedEvent.value.description), 1),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (isDetailOpen.value = false)),
                  class: "close-btn"
                }, "닫기")
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})